// Loaded before app.js
require('./helpers/polyfills.js');
require('./helpers/validation.js');